// Calendar.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Calendar.css';
import { useLocation } from 'react-router-dom';

const Calendar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [cropData, setCropData] = useState([]);

  const farmname = location.state?.farmname || '';
  const soiltype = location.state?.soiltype || '';
  const selectCountry = location.state?.selectCountry || '';
  console.log(selectCountry)
   console.log(farmname)
  useEffect(() => {
    // Fetch data from the API when the component mounts
    const fetchData = async () => {
      try {
        const response = await fetch(`https://quickstart-mmapfxurda-ew.a.run.app/api/crop-information/?country=${ selectCountry}&farming_region=${farmname}`);
        const data = await response.json();
        console.log(data)
        setCropData(data);
      } catch (error) {
        console.error('Error fetching crop data:', error);
      }
    };

    fetchData();
  }, [farmname]); // Run the effect when farmname changes

  const handleCloseClick = () => {
    navigate('/');
  };

  const uniqueCropNames = new Set();
  const uniqueCrops = cropData.filter((crop) => {
    if (!uniqueCropNames.has(crop.crop)) {
      uniqueCropNames.add(crop.crop);
      return true;
    }
    return false;
  });
  
  const crops = uniqueCrops.map((crop) => ({
    name: crop.crop,
    planting: [crop.early_sowing_month, crop.late_sowing_month, crop.early_sowing_day, crop.late_sowing_day],
    harvesting: [crop.early_harvest_month, crop.late_harvest_month, crop.early_harvest_day, crop.late_harvest_day],
  })).sort((a, b) => a.name.localeCompare(b.name));
  

  const planting_getColor = (crop, month) => {
    const { planting } = crop;
    console.log('planting:', planting);
    const [startMonth, endMonth] = planting;
    console.log('startMonth:', startMonth);
    console.log('endMonth:', endMonth);
  
    if (startMonth <= endMonth) {
      if (month >= startMonth && month <= endMonth) {
        return '#6db753'; // Planting color
      }
    } else {
      // Crossover case: planting months span across years
      if (month >= startMonth || month <= endMonth) {
        return '#6db753'; // Planting color
      }
    }
  
    return 'transparent'; // Default color
  };
  
  
  const harvesting_getColor = (crop, month) => {
    const { harvesting } = crop;
    console.log('harvesting:', harvesting);
    const [startMonth, endMonth] = harvesting;
    console.log('startMonth:', startMonth);
    console.log('endMonth:', endMonth);
  
    if (startMonth <= endMonth) {
      if (month >= startMonth && month <= endMonth) {
        return '#314a5e'; // Harvesting color
      }
    } else {
      // Crossover case: harvesting months span across years
      if (month >= startMonth || month <= endMonth) {
        return '#314a5e'; // Harvesting color
      }
    }
  
    return 'transparent'; // Default color
  };
  

  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  return (
    <div className="calendar-container">
        <div className="calendar-header">
        <h1><span class="key">Farming Region:</span> <span class="value">{farmname}</span></h1>
<h1><span class="key">Soil Type:</span> <span class="value">{soiltype}</span></h1>
      </div>
      <button className="close-calendar" onClick={handleCloseClick}>
        <i className="fas fa-arrow-left" title="Back to home page"></i>
      </button>
      <div className="legend">
        <div className="legend-item">
          <div className="legend-color" style={{ backgroundColor: '#6db753' }}></div>
          <div className="legend-text-Planting">Planting</div>
        </div>
        <div className="legend-item">
          <div className="legend-color" style={{ backgroundColor: '#314a5e' }}></div>
          <div className="legend-text-Harvesting">Harvesting</div>
        </div>
      </div>

      <div className="table-container">
        <table className="crop-table">
          <thead>
            <tr>
              <th className='head'>Crop List</th>
              {months.map((month, index) => (
                <React.Fragment key={index}>
                  <th className="separator-vertical"></th>
                  <th className='head'>{month}</th>
                </React.Fragment>
              ))}
            </tr>
          </thead>
          <tbody className="crop-body">
            {crops.map((crop, cropIndex) => (
              <tr key={cropIndex}>
                <td>{crop.name}</td>
                {months.map((month, monthIndex) => (
                  <React.Fragment key={monthIndex}>
                    <td className="separator-vertical"></td>
                    <td>
                      <div
                        className='color'
                        style={{ backgroundColor: planting_getColor(crop, monthIndex + 1) }}
                        title={`Planting: ${crop.planting[0]}/${crop.planting[2]} - ${crop.planting[1]}/${crop.planting[3]}`}
                      ></div>
                      <div
                        className='color'
                        style={{ backgroundColor: harvesting_getColor(crop, monthIndex + 1) }}
                        title={`Harvesting: ${crop.harvesting[0]}/${crop.harvesting[2]} - ${crop.harvesting[1]}/${crop.harvesting[3]}`}
                      ></div>
                    </td>
                  </React.Fragment>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Calendar;
